import { AxiosResponse } from 'axios'
import humps from 'humps'

export const camelizeKeysInterceptor = (response: AxiosResponse) => {
  if (response.data) {
    response.data = humps.camelizeKeys(response.data)
  }

  return response
}
